import * as Yup from "yup";

export const EditCommentSchema = Yup.object().shape({
	comment : Yup.string().min(1).max(30, "Le commentaire ne peut contenir plus de 30 caractères").required("Veuillez entrer un commentaire"),
})